module.exports = __webpack_public_path__ + "img/oran.212799bc.png";